import {Component, forwardRef, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {EmailSettingSearchModel} from "../email-setting-search.model";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";

const CUSTOM_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => EmailSettingSingleSelectEditControlComponent),
    multi: true
};

@Component({
    selector: "wbo-email-setting-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        CUSTOM_VALUE_ACCESSOR,
        provideSearchModel(EmailSettingSearchModel)
    ]
})
export class EmailSettingSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<EmailSettingSearchModel> {
    constructor(model: EmailSettingSearchModel, injector: Injector) {
        super(model, injector, "emailSettingId", "name");
    }
}
